<template>
  <div class="expert-extraction-audit">
    <!-- 页面标题 -->
    <div class="page-header">
      <div class="header-left">
        <h2>专家抽取审核</h2>
      </div>
    </div>
    <!-- 搜索区域 -->
    <div class="search-section">
      <div class="search-form">
        <div class="search-item">
          <label class="search-label">招标项目名称</label>
          <el-input v-model="searchForm.projectName" placeholder="请输入招标项目名称" clearable class="search-input"></el-input>
        </div>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch" class="search-btn">
          查询
        </el-button>
      </div>
    </div>
    <!-- 表格区域 -->
    <div class="table-section">
      <el-table :data="tableData" border style="width: 100%" class="audit-table">
        <el-table-column prop="projectName" label="招标项目名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="sectionName" label="标段名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="major" label="专业" show-overflow-tooltip></el-table-column>
        <el-table-column prop="personCount" label="抽取总人数" align="center"></el-table-column>
        <el-table-column prop="createTime" label="申请时间" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.selectionStatus)" size="small">
              {{ getDocumentStatusText(scope.row.selectionStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="220">
          <template slot-scope="scope">
            <div class="action-btn-group">
              <el-button type="primary" size="mini" icon="el-icon-document" @click="handleViewDetails(scope.row)"
                v-if="scope.row.selectionStatus == 1">
                详情
              </el-button>
              <el-button type="success" size="mini" icon="el-icon-coordinate" @click="handleAudit(scope.row)"
                v-if="scope.row.status == 0">
                审核
              </el-button>
              <el-button type="warning" size="mini" icon="el-icon-thumb" @click="handleExtract(scope.row)"
                v-if="scope.row.status == 1 && scope.row.selectionStatus == 0">
                抽取
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页区域 -->
    <div class="pagination-section">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="total" class="pagination"></el-pagination>
    </div>
    <!-- 详情弹窗 -->
    <el-dialog :visible.sync="detailDialogVisible" width="50%" :close-on-click-modal="false" :append-to-body="true"
      class="detail-dialog" title="专家抽取审核">
      <div class="detail-content">
        <!-- 基本信息 -->
        <div class="project-info-section">
          <div class="section-title">基本信息</div>
          <div class="info-grid">
            <div class="info-item">
              <label class="info-label">项目编号</label>
              <span class="info-value">{{ detailData.projectCode || '-' }}</span>
            </div>
            <div class="info-item">
              <label class="info-label">项目名称</label>
              <span class="info-value">{{ detailData.projectName || '-' }}</span>
            </div>
            <div class="info-item">
              <label class="info-label">评审时间</label>
              <span class="info-value">{{ detailData.reviewTime || '-' }}</span>
            </div>
            <div class="info-item">
              <label class="info-label">评审流程</label>
              <span class="info-value">{{ getReviewProcessText(detailData.reviewProcess) }}</span>
            </div>
            <div class="info-item">
              <label class="info-label">抽取人数</label>
              <span class="info-value">{{ detailData.selectionCount !== null && detailData.selectionCount !== undefined
                ?
                detailData.selectionCount : '-' }}</span>
            </div>
            <div class="info-item">
              <label class="info-label">招标人代表数</label>
              <span class="info-value">{{ detailData.representCount !== null && detailData.representCount !== undefined
                ?
                detailData.representCount : '-' }}</span>
            </div>
            <!-- <div class="info-item">
              <label class="info-label">评审时长(天)</label>
              <span class="info-value">{{ detailData.durationTime !== null && detailData.durationTime !== undefined ?
                detailData.durationTime : '-' }}</span>
            </div> -->
            <div class="info-item">
              <label class="info-label">抽取状态</label>
              <span class="info-value">{{ getSelectionStatusText(detailData.selectionStatus) }}</span>
            </div>
            <div class="info-item info-item--full">
              <label class="info-label">评审地点</label>
              <span class="info-value">{{ detailData.address || '-' }}</span>
            </div>
            <div class="info-item info-item--full">
              <label class="info-label">标段编号</label>
              <span class="info-value">
                <span v-if="detailData.sectionCodes && detailData.sectionCodes.length > 0">
                  {{ detailData.sectionCodes.join('、') }}
                </span>
                <span v-else>-</span>
              </span>
            </div>
          </div>
        </div>

        <!-- 联系方式 -->
        <div class="main-info-section">
          <div class="section-title">联系方式</div>
          <div class="info-grid">
            <div class="info-item">
              <label class="info-label">联系人</label>
              <span class="info-value">{{ detailData.contactName || '-' }}</span>
            </div>
            <div class="info-item">
              <label class="info-label">联系电话</label>
              <span class="info-value">{{ detailData.contactMobile || '-' }}</span>
            </div>
          </div>
        </div>

        <!-- 抽取地区 -->
        <div class="recusal-section" v-if="detailData.areaList && detailData.areaList.length > 0">
          <div class="section-title">抽取地区</div>
          <el-table :data="detailData.areaList" class="recusal-table" border>
            <el-table-column prop="provinceName" label="省" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="cityName" label="市" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="countyName" label="区县" min-width="120" show-overflow-tooltip></el-table-column>
          </el-table>
        </div>

        <!-- 招标人代表 -->
        <div class="bidder-contact-section" v-if="detailData.representList && detailData.representList.length > 0">
          <div class="section-title">招标人代表</div>
          <el-table :data="detailData.representList" border class="contact-table">
            <el-table-column prop="representName" label="姓名" width="140" align="center"></el-table-column>
            <el-table-column prop="workUnit" label="工作单位" min-width="220" show-overflow-tooltip></el-table-column>
            <el-table-column prop="mobile" label="联系方式" width="150" align="center"></el-table-column>
            <el-table-column prop="idCard" label="证件号" min-width="160" show-overflow-tooltip></el-table-column>
          </el-table>
        </div>

        <!-- 抽取行业 -->
        <div class="specialty-section" v-if="detailData.industryList && detailData.industryList.length > 0">
          <div class="section-title">抽取行业</div>
          <el-table :data="detailData.industryList" border class="specialty-table">
            <el-table-column prop="industryName" label="行业名称" min-width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="industryCode" label="行业编码" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="personNum" label="人数" width="100" align="center"></el-table-column>
          </el-table>
        </div>

        <!-- 回避单位/公司 -->
        <div class="specialty-section" v-if="detailData.companyDtoList && detailData.companyDtoList.length > 0">
          <div class="section-title">回避单位</div>
          <el-table :data="detailData.companyDtoList" border class="specialty-table">
            <el-table-column prop="companyName" label="单位名称" min-width="260" show-overflow-tooltip></el-table-column>
          </el-table>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getExpertSelectionAuditList,
  passExpertSelection,
  getExpertSelectionDetails,
  expertSelection
} from '@/api/modules/expertSelection'

export default {
  name: 'ExpertExtractionAudit',
  data() {
    return {
      // 详情弹窗
      detailDialogVisible: false,
      detailData: {
        address: '',
        areaList: [],
        companyDtoList: [],
        contactMobile: '',
        contactName: '',
        durationTime: 0,
        id: 0,
        industryList: [],
        projectCode: '',
        projectName: '',
        representCount: 0,
        representList: [],
        reviewProcess: 0,
        reviewTime: '',
        sectionCodes: [],
        selectPerson: 0,
        selectionCount: 0,
        selectionStatus: 0
      },

      // 搜索表单
      searchForm: {
        projectName: '',
      },
      // 表格数据
      tableData: [],
      // 分页数据
      currentPage: 1,
      pageSize: 10,
      total: 1
    }
  },
  computed: {
    channelCode() {
      return this.$channelMaterial.getChannelCode()
    },
  },
  mounted() {
    // 页面初始化
    this.loadData();
  },
  methods: {
    // 加载数据
    loadData() {
      this.getExpertSelectionAuditList()
    },
    //获取列表
    getExpertSelectionAuditList() {
      getExpertSelectionAuditList({
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        projectName: this.searchForm.projectName,
        channelCode: this.channelCode
      }).then(res => {
        if (res.code === 200) {
          this.total = res.data.total || 0;
          this.tableData = res.data.records || [];
        }
      })
    },
    // 审核
    handleAudit(row) {



      // passExpertSelection({ id: row.id, channelCode: this.channelCode }).then(res => {
      //   if (res.code === 200) {
      //     setTimeout(() => {
      //       clearInterval(timer)
      //       loading.close()
      //       this.$message.success('抽取成功')
      //     }, 3500);


      //     expertSelection({ id: row.id, channelCode: this.channelCode }).then(res => {
      //       if (res.code === 200) {
      //         this.$message.success('审核成功')
      //         this.loadData()
      //       } else {
      //         this.$message.error(res.msg)
      //       }
      //     })

      //   } else {
      //     this.$message.error(res.msg)
      //   }
      // }).catch(() => {
      //   clearInterval(timer)
      //   loading.close()
      //   this.$message.error('抽取失败，请重试')
      // })

      this.$confirm('是否要审核当前项目?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        passExpertSelection({ id: row.id, channelCode: this.channelCode }).then(res => {
          if (res.code === 200) {
            this.$message.success('审核成功')
            this.loadData()
          } else {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {
      })
    },
    // 抽取
    handleExtract(row) {
      this.$confirm('是否要抽取当前项目?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const texts = [
          '正在努力抽取中，请稍候...',
          '专家匹配中，请耐心等待...',
          '正在筛选最优专家...',
          '即将完成抽取...'
        ]
        let textIndex = 0
        const loading = this.$loading({
          lock: true,
          text: texts[0],
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
          customClass: 'extract-loading'
        })
        const timer = setInterval(() => {
          textIndex = (textIndex + 1) % texts.length
          loading.text = texts[textIndex]
        }, 1000)
        expertSelection({ id: row.id, channelCode: this.channelCode }).then(res => {
          if (res.code === 200) {
            setTimeout(() => {
              clearInterval(timer)
              loading.close()
              this.$message.success('抽取成功')
            }, 3500);
            this.loadData()
          } else {
            clearInterval(timer)
            loading.close()
            this.$message.error(res.msg)
          }
        }).catch(() => {
          clearInterval(timer)
          loading.close()
          this.$message.error('抽取失败，请重试')
        })
      }).catch(() => {
      })

    },

    // 搜索
    handleSearch() {
      console.log('搜索条件:', this.searchForm);
      this.currentPage = 1;
      this.loadData();
    },
    // 查看详情
    handleViewDetails(row) {
      this.getExpertSelectionDetails(row)
    },
    // 调用查看详情接口
    getExpertSelectionDetails(row) {
      getExpertSelectionDetails({
        id: row.id,
        channelCode: this.channelCode
      }).then(res => {
        if (res.code === 200) {
          this.detailDialogVisible = true;
          this.detailData = res.data || {}

        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 分页大小改变
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadData();
    },
    // 当前页改变
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadData();
    },
    // 处理状态

    /**
  * 获取文件编制状态文本
  */
    getDocumentStatusText(status) {
      const statusMap = {
        0: '待抽取',
        1: '抽取成功',
      }
      return statusMap[status] || '-'
    },

    getStatusType(status) {
      const statusMap = {
        0: 'info',
        1: 'success'
      }
      return statusMap[status] || 'info'
    },

    getReviewProcessText(reviewProcess) {
      const map = {
        0: '-',
        1: '一阶段',
        2: '二阶段'
      }
      return map[reviewProcess] || '-'
    },

    getSelectionStatusText(selectionStatus) {
      const map = {
        0: '待抽取',
        1: '已抽取',
        2: '已完成'
      }
      return map[selectionStatus] || '-'
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.expert-extraction-audit {
  .apply-minimal-gray-theme();
}

.action-btn-group {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  justify-content: center;
  align-items: center;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;

  .header-left {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }

  h2 {
    font-size: 20px;
    font-weight: 600;
    color: @gray-700;
    margin: 0;
    line-height: 1.5;
    position: relative;
    padding-left: 10px;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 16px;
      background: @primary-color;
      border-radius: 2px;
    }
  }
}

.search-section {
  background: #fff;
  padding: 16px 20px;
  border-radius: 4px;
  box-shadow: @shadow-sm;
  margin-bottom: 16px;
}

.search-form {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.search-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.search-label {
  font-size: 14px;
  color: @gray-600;
  font-weight: 500;
  white-space: nowrap;
  min-width: 100px;
  text-align: right;
}

.search-input {
  width: 200px;
}

.search-btn {
  margin-left: 10px;
}

/deep/ .el-input__inner {
  border-color: @gray-300;
  color: @gray-700;

  &:focus {
    border-color: @primary-color;
  }

  &::placeholder {
    color: @gray-400;
  }
}

.table-section {
  background: #fff;
  border-radius: 4px;
  box-shadow: @shadow-sm;
  padding: 20px;
  margin-bottom: 16px;
  overflow: hidden;
}

.audit-table {
  /deep/ .el-table__header th {
    background-color: @gray-50 !important;
    color: @gray-700 !important;
    font-weight: 600;
    border-color: @gray-200 !important;
  }

  /deep/ .el-table__body td {
    color: @gray-600;
    border-color: @gray-200 !important;
  }

  /deep/ .el-table__row:hover {
    background-color: @gray-50;
  }

  /deep/ .el-button--primary.el-button--mini {
    background-color: @primary-color;
    border-color: @primary-color;

    &:hover,
    &:focus {
      background-color: @primary-hover;
      border-color: @primary-hover;
    }
  }
}

.pagination-section {
  padding: 16px 20px;
  display: flex;
  justify-content: flex-end;
  background: #fff;
  border-radius: 4px;
  box-shadow: @shadow-sm;
}

.detail-dialog {
  /deep/ .el-dialog__header {
    background: @gray-50;
    border-bottom: 1px solid @gray-200;
  }

  /deep/ .el-dialog__title {
    color: @gray-700;
    font-weight: 600;
  }

  /deep/ .el-dialog__body {
    padding: 20px;
  }
}

.detail-content {
  background: #fff;
}

.project-info-section,
.main-info-section,
.bidder-contact-section,
.recusal-section,
.specialty-section {
  margin-bottom: 20px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: @gray-700;
  margin-bottom: 12px;
  padding-left: 10px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 16px;
    background: @gray-700;
    border-radius: 2px;
  }
}

.info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px 40px;
  margin-bottom: 10px;
}

.info-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.info-item--full {
  grid-column: 1 / -1;
}

.info-label {
  font-size: 14px;
  color: @gray-600;
  font-weight: 500;
  text-align: right;
  margin-right: 10px;
}

.info-value {
  font-size: 14px;
  color: @gray-700;
  flex: 1;
}

.main-info-section {
  display: flex;
  gap: 40px;
}

.left-column,
.right-column {
  flex: 1;
}

.contact-table,
.recusal-table,
.specialty-table {
  width: 100%;

  /deep/ .el-table__header th {
    background-color: @gray-100;
    color: @gray-700;
    font-weight: 600;
  }
}

.dialog-footer {
  text-align: right;
  padding-top: 20px;
  border-top: 1px solid @gray-200;

  .el-button {
    margin-left: 10px;
  }
}

/deep/ .el-tag--success {
  background: fade(@success-color, 10%);
  color: @success-color;
  border-color: fade(@success-color, 20%);
}

/deep/ .el-tag--info {
  background: @gray-100;
  color: @gray-600;
  border-color: @gray-200;
}

@media (max-width: 1200px) {
  .main-info-section {
    flex-direction: column;
    gap: 20px;
  }

  .info-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .info-label {
    text-align: left;
    margin-bottom: 5px;
  }
}

@media (max-width: 768px) {
  .detail-dialog {
    width: 95% !important;
  }

  .detail-dialog /deep/ .el-dialog__body {
    padding: 15px;
  }

  .info-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .contact-table /deep/ .el-table__body-wrapper,
  .specialty-table /deep/ .el-table__body-wrapper,
  .recusal-table /deep/ .el-table__body-wrapper {
    overflow-x: auto;
  }
}
</style>

<style>
.extract-loading .el-loading-spinner .el-icon-loading {
  font-size: 42px;
  color: #409EFF;
}

.extract-loading .el-loading-spinner .el-loading-text {
  font-size: 18px;
  color: #fff;
  margin-top: 12px;
}
</style>
